import React from 'react';
import './Team.css';

const Team = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Jiannong Cao',
      role: 'Project Coordinator',
      description: 'Otto Poon Charitable Foundation Prof. in Data Sci., Chair Professor in Mobile and Distributed Computing, Director of RIAIoT, MAE, FHKEng, FIEEE, FCCF',
      avatar: '/images/team/Jiannong_Cao.png',
      university: 'The Hong Kong Polytechnic University'
    },
    {
      id: 2,
      name: 'Michael Lyu',
      role: 'Co-PI',
      description: 'Choh-Ming Li Professor, Department of the Computer Science and Engineering, IEEE Fellow, ACM Fellow, AAAS Fellow, HKAES Fellow',
      avatar: '/images/team/Michael_Lyu.jpg',
      university: 'The Chinese University of Hong Kong'
    },
    {
      id: 3,
      name: 'Xiaofang Zhou',
      role: 'Co-PI',
      description: 'Head of CSE, Chair Professor, Otto Poon Professor of Engineering, IEEE Fellow',
      avatar: '/images/team/Xiaofang_Zhou.jpg',
      university: 'The Hong Kong University of Science and Technology'
    },
    {
      id: 4,
      name: 'Qing Li',
      role: 'Co-PI',
      description: 'Chair Professor in Data Science, Head of Department of Computing, IET/IEEE Fellow',
      avatar: '/images/team/Qing_Li.jpg',
      university: 'The Hong Kong Polytechnic University'
    },
    {
      id: 5,
      name: 'Wenzhong Shi',
      role: 'Co-PI',
      description: 'Otto Poon Charitable Foundation Professor in Urban Informatics, Chair Professor, Director of SCRI',
      avatar: '/images/team/Wenzhong_Shi.jpg',
      university: 'The Hong Kong Polytechnic University'
    },
    {
      id: 6,
      name: 'Bo Li',
      role: 'Co-PI',
      description: 'Chair Professor, Department of Computer Science and Engineering, IEEE Fellow, Cheung Kong Scholar',
      avatar: '/images/team/Bo_Li.jpg',
      university: 'The Hong Kong University of Science and Technology'
    },
    {
      id: 7,
      name: 'Guoliang Xing',
      role: 'Co-PI',
      description: 'Professor, Department of Information Engineering, IEEE Fellow, ACM Fellow',
      avatar: '/images/team/Guoliang_Xing.jpg',
      university: 'The Chinese University of Hong Kong'
    },
    {
      id: 8,
      name: 'Chuan Wu',
      role: 'Co-PI',
      description: 'Professor, Department of Computer Science, IEEE Fellow',
      avatar: '/images/team/Chuan_Wu.jpg',
      university: 'The University of Hong Kong'
    },
    {
      id: 9,
      name: 'Xiapu Luo',
      role: 'Co-PI',
      description: 'Professor, Associate Dean of the Faculty of Computer and Mathematical Sciences',
      avatar: '/images/team/Xiapu_Luo.jpg',
      university: 'The Hong Kong Polytechnic University'
    },
    {
      id: 10,
      name: 'Lei Yang',
      role: 'Co-PI',
      description: 'Professor, School of Software Engineering',
      avatar: '/images/team/Lei_Yang.jpg',
      university: 'South China University of Technology'
    },
    {
      id: 11,
      name: 'Shan Jiang',
      role: 'Co-PI',
      description: 'Associate Professor, School of Software Engineering',
      avatar: '/images/team/Shan_Jiang.jpg',
      university: 'Sun Yat-sen University'
    }
  ];

  return (
    <section className="team section">
      <div className="container">
        <h2 className="section-title">Team Members</h2>
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-member">
              <div className="member-avatar">
                <img src={member.avatar} alt={member.name} className="avatar-image" />
              </div>
              <div className="member-info">
                <h3 className="member-name">{member.name}</h3>
                <p className="member-role">{member.role}</p>
                {member.university && (
                  <p className="member-university">{member.university}</p>
                )}
                <p className="member-description">{member.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team; 